<template>
  <div class="content-p" v-if="visible">
    <div class="content" :style="{ height: height, width: width }">
      <!-- 头部区域 - 支持自定义内容 -->
      <div class="top" v-if="showHeader">
        <slot name="header">
          <span class="title">{{ title }}</span>
        </slot>
        <div class="icon-css" @click="closeModal" v-if="showCloseIcon">
          <el-icon><Close /></el-icon>
        </div>
      </div>

      <!-- 内容区域 - 支持自定义内容 -->
      <div class="data" :style="{ background: dataBg }">
        <slot></slot>
      </div>

      <!-- 底部区域 - 支持自定义内容 -->
      <div class="footer" v-if="showFooter">
        <slot name="footer">
          <el-button type="primary" @click="primaryButtonClick">{{
            primaryButtonText
          }}</el-button>
          <el-button @click="closeModal">{{ secondaryButtonText }}</el-button>
        </slot>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { ref, defineComponent, onMounted, onBeforeUnmount, watch } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";

export default defineComponent({
  name: "CommonModal",

  components: {},

  props: {
    // 控制模态框显示/隐藏
    visible: {
      type: Boolean,
      default: false,
    },

    // 头部配置
    title: {
      type: String,
      default: "默认标题",
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },

    // 底部配置
    showFooter: {
      type: Boolean,
      default: true,
    },
    primaryButtonText: {
      type: String,
      default: "确认",
    },
    secondaryButtonText: {
      type: String,
      default: "关闭",
    },

    // 样式配置
    width: {
      type: String,
      default: "500px",
    },
    height: {
      type: String,
      default: "350px",
    },
    dataBg: {
      type: String,
      default: "#fff",
    },
  },

  emits: ["update:visible", "primary-button-click", "close"],

  setup(props, { emit }) {
    // 内部可见性状态，用于控制动画过渡
    const internalVisible = ref(props.visible);

    // 监听外部可见性变化
    watch(
      () => props.visible,
      (newVal) => {
        internalVisible.value = newVal;
      }
    );

    // 关闭模态框
    const closeModal = () => {
      emit("update:visible", false);
      emit("close");
    };

    // 主按钮点击事件
    const primaryButtonClick = () => {
      emit("primary-button-click");
    };

    return {
      internalVisible,
      closeModal,
      primaryButtonClick,
    };
  },
});
</script>
  
  <style scoped>
.content-p {
  width: 100%;
  height: 100vh;
  background: rgb(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
}

.content {
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 350px;
}

.top {
  padding: 0 20px;
  background: #f8f8f8;
  color: #333;
  font-size: 14px;
  height: 42px;
  line-height: 42px;
  border: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.title {
  font-size: 16px;
}

.icon-css {
  font-size: 18px;
  cursor: pointer;
}

.data {
  background-color: #fff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  -webkit-border-image: none;
  -o-border-image: none;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
  flex-grow: 1;
  color: #676a6c;
  font-size: 14px;
  overflow: hidden;
}

.footer {
  height: 55px;
  text-align: right;
  padding: 10px 15px 12px;
  background: #f0f4f7;
  border-top: 1px #c7c7c7 solid;
  box-sizing: border-box;
}
</style>